import { render, staticRenderFns } from "./HijackableAssetIssueBody.vue?vue&type=template&id=722f8397&scoped=true"
import script from "./HijackableAssetIssueBody.vue?vue&type=script&lang=js"
export * from "./HijackableAssetIssueBody.vue?vue&type=script&lang=js"
import style0 from "./HijackableAssetIssueBody.vue?vue&type=style&index=0&id=722f8397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f8397",
  null
  
)

export default component.exports